import { UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query';
import { QueryKey } from 'common/enums/query-key';
import { ScreeningServicePlan } from 'common/types/services/api/tenant-screening';
import RequestedScreeningServicePlan from 'common/types/services/api/tenant-screening/RequestedScreeningServicePlan';
import { getOrderPlans, getRequestedOrderPlans } from 'services/api/background-check-api.service';

type Variables = { location: string; tenantId: string; rentApplicationId: string; requestorId?: string; };

export function useGetOrderPlans(
    variables: Variables,
    options?: Omit<
      UndefinedInitialDataOptions<ScreeningServicePlan[], Error, ScreeningServicePlan[], string[]>,
      'queryFn' | 'queryKey'
    >,
  ) {
    return useQuery({
      queryKey: [QueryKey.TenantScreening, 'orders', variables.tenantId, variables.location],
      queryFn: () => getOrderPlans(variables.tenantId, variables.rentApplicationId, variables.location, variables.requestorId || ''),
      ...options,
    });
  }
  
  type GetRequestedOrders = { location: string; tenantId: string; requestorId: string; rentApplicationId: string };
  export function useGetRequestedOrderPlans(
    variables: GetRequestedOrders,
    options?: Omit<
      UndefinedInitialDataOptions<RequestedScreeningServicePlan[], Error, RequestedScreeningServicePlan[], string[]>,
      'queryFn' | 'queryKey'
    >,
  ) {
    return useQuery({
      queryKey: [QueryKey.TenantScreening, 'requestedOrders', variables.tenantId, variables.location],
      queryFn: () => getRequestedOrderPlans(variables.tenantId, variables.requestorId, variables.rentApplicationId, variables.location),
      ...options,
    });
  }